import React, { useState, useEffect } from "react";
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CListGroup,
  CListGroupItem,
  CSpinner,
  CButton,
  CBadge,
} from "@coreui/react";
import { resellerAPI } from "../services/api";
import CreateResellerUserModal from "../components/Auth/CreateResellerUserModal"; // NEW IMPORT

const Profile = () => {
  const [reseller, setReseller] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    fetchProfile();
    const userInfo = localStorage.getItem("userInfo");
    const resellerData = localStorage.getItem("user");

    if (userInfo) {
      setCurrentUser(JSON.parse(userInfo));
    } else if (resellerData) {
      const reseller = JSON.parse(resellerData);
      const fallbackUserInfo = {
        id: reseller.id,
        name: reseller.name,
        email: reseller.email,
        role: "admin",
        user_type: "admin",
        is_admin: true,
      };
      setCurrentUser(fallbackUserInfo);
      localStorage.setItem("userInfo", JSON.stringify(fallbackUserInfo));
    }
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await resellerAPI.getProfile();
      if (response.data.success) {
        setReseller(response.data.reseller);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserAdded = () => {
    console.log("User added successfully");
  };

  const handleAddUserClick = () => {
    setShowAddUserModal(true);
  };

  const handleCloseModal = () => {
    setShowAddUserModal(false);
  };

  const isAdmin =
    currentUser?.user_type === "admin" ||
    currentUser?.role === "admin" ||
    currentUser?.is_admin === true;

  if (loading) {
    return (
      <CContainer className="d-flex justify-content-center align-items-center min-vh-50">
        <CSpinner color="primary" />
      </CContainer>
    );
  }

  return (
    <div style={{ position: "relative", zIndex: 1 }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Reseller Profile</h2>

        {isAdmin && (
          <CButton color="primary" onClick={handleAddUserClick}>
            <i className="cil-user-plus me-2"></i>
            Add Reseller User
          </CButton>
        )}
      </div>

      {currentUser && (
        <div className="mb-3">
          <CBadge
            color={isAdmin ? "primary" : "secondary"}
            className="fs-6 p-2"
          >
            <i className={`cil-${isAdmin ? "user" : "user"} me-1`}></i>
            Logged in as: {isAdmin ? "Reseller Admin" : currentUser.role}
          </CBadge>
        </div>
      )}

      <CRow>
        <CCol md={8}>
          <CCard>
            <CCardHeader className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Reseller Information</h5>
              {isAdmin && (
                <CBadge color="success" className="fs-6">
                  Admin Access
                </CBadge>
              )}
            </CCardHeader>
            <CCardBody>
              {reseller && (
                <CListGroup flush>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Reseller ID:</strong>
                    <span>{reseller.resellerId}</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Company Name:</strong>
                    <span>{reseller.company_name}</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Email:</strong>
                    <span>{reseller.email}</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Location:</strong>
                    <span>{reseller.location}</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Margin:</strong>
                    <span>{reseller.margin}%</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Active Subscriptions:</strong>
                    <span>{reseller.active_subscriptions}</span>
                  </CListGroupItem>
                  <CListGroupItem>
                    <strong>Notes:</strong>
                    <div className="mt-1">
                      {reseller.notes || "No notes available"}
                    </div>
                  </CListGroupItem>
                </CListGroup>
              )}
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={4}>
          <CCard>
            <CCardHeader>
              <h5 className="mb-0">Your Account</h5>
            </CCardHeader>
            <CCardBody>
              {currentUser && (
                <CListGroup flush>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Name:</strong>
                    <span>{currentUser.name}</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Email:</strong>
                    <span>{currentUser.email}</span>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Role:</strong>
                    <CBadge color={isAdmin ? "primary" : "secondary"}>
                      {currentUser.role}
                    </CBadge>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>User Type:</strong>
                    <CBadge color={isAdmin ? "success" : "info"}>
                      {currentUser.user_type}
                    </CBadge>
                  </CListGroupItem>
                  <CListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Admin Access:</strong>
                    <CBadge color={isAdmin ? "success" : "secondary"}>
                      {isAdmin ? "Yes" : "No"}
                    </CBadge>
                  </CListGroupItem>
                </CListGroup>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      {/* Use the NEW modal component */}
      {/* Use the NEW modal component */}
      <CreateResellerUserModal
        show={showAddUserModal}
        onClose={handleCloseModal}
        onUserAdded={handleUserAdded}
      />
    </div>
  );
};

export default Profile;
